<template>
  <div class="img-view">
    <el-carousel
      ref="carousel"
      v-if="images"
      :autoplay="false"
      :arrow="images.length == 1 ? 'never':'always'"
    >
      <el-carousel-item v-for="(item,index) in images" :key="index">
        <img :src="item" alt="">
      </el-carousel-item>
    </el-carousel>
    <p>{{ text }}</p>
    <div class="views" :class="{'scroll':images.length>7}">
      <div v-for="(item,index) in images"
           :key="index"
           :class="{active:index===activeIndex}" @click="changeImg(index)">
        <img :src="item" alt="">
      </div>
    </div>
    <div class="content cms-style" v-html="content" v-if="content"></div>
  </div>
</template>

<script>
export default {
  props: {
    images: {
      type: Array,
    },
    text: {
      type: String,
    },
    content: {
      type: String,
    }
  },
  data() {
    return {
      isMounted: false
    }
  },
  computed: {
    activeIndex() {
      if (this.isMounted) {
        return this.$refs.carousel.activeIndex
      } else return 0
    }
  },
  methods: {
    changeImg(index) {
      this.$refs.carousel.setActiveItem(index)
    }
  },
  mounted() {
    this.isMounted = true;
  }
}
</script>

